module.exports = __webpack_public_path__ + "static/avatar-4bf0e5aacc2908fff8d659b928b74088.jpg";